import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AutomationService {
    private _campaignsApiBaseUrl: string = '';

    public constructor(
        private appService: AppService,
        public http: HttpClient,
        @Inject('CAMPAIGNS_API_BASE_URL') campaignsApiUrl: string,
    ) {
        this._campaignsApiBaseUrl = campaignsApiUrl;
    }

    public getFrozenCreditors = (): Observable<any> => {
        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
        const apipath: string = 'service-maintenance/frozen-creditors';
        const fullPath: string = this._campaignsApiBaseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        return this.http.get<any>(fullPath, options);
    };

    public postFreezeUnFreezeCreditor = (
        creditorId: string,
        freeze: boolean,
    ): Observable<any> => {
        const apipath: string =
            'service-maintenance/freeze-creditor/' + freeze + '/' + creditorId;
        const fullPath: string = this._campaignsApiBaseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.post<any>(fullPath, null, options);
    };
}
